export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8194.93a1e412.jpg";